import React, { FC } from "react";
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import type { GradingLevelType } from "../../hooks";

import { Button } from "@components/base";

interface GradeOverwriteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (gradingLevel: GradingLevelType) => void;
  selectedGradingLevel: GradingLevelType;
  onGradingLevelChange: (level: GradingLevelType) => void;
}

export const GradeOverwriteDialog: FC<GradeOverwriteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedGradingLevel,
  onGradingLevelChange,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("paygap.gradeEstimator.applyGradesConfirmTitle")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t("paygap.gradeEstimator.applyGradesConfirmMessage")}
        </Typography>

        <Box sx={{ mb: 2 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="grading-level-dialog-label">
              {t("paygap.gradeEstimator.selectGradingLevel", "Select grading level")}
            </InputLabel>
            <Select
              labelId="grading-level-dialog-label"
              value={selectedGradingLevel}
              label={t("paygap.gradeEstimator.selectGradingLevel", "Select grading level")}
              onChange={(e): void => onGradingLevelChange(e.target.value as GradingLevelType)}
            >
              <MenuItem value="levelOfRequirements">
                {t("paygap.gradeEstimator.levelOfRequirements1", "Level of Requirements - 1")}
              </MenuItem>
              <MenuItem value="levelOfRequirements2">
                {t("paygap.gradeEstimator.levelOfRequirements2", "Level of Requirements - 2")}
              </MenuItem>
              <MenuItem value="levelOfRequirements3">
                {t("paygap.gradeEstimator.levelOfRequirements3", "Level of Requirements - 3")}
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Alert severity="warning">
          <Typography variant="body2">
            {t(
              "paygap.gradeEstimator.overwriteWarning",
              "This will overwrite existing data in the selected column for all employees!"
            )}
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t("paygap.gradeEstimator.applyGradesConfirmCancel")}
        </Button>
        <Button onClick={(): void => onConfirm(selectedGradingLevel)} variant="contained" color="primary">
          {t("paygap.gradeEstimator.applyGradesConfirmConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
